import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import * as moment from 'moment'
/**
 * Generated class for the ExpenseItemCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-expense-item-create',
  templateUrl: 'expense-item-create.html',
})
export class ExpenseItemCreatePage {

  expenseItem: any;
  constructor(public navCtrl: NavController, 
  	public navParams: NavParams,
  	private rhynoApi: RhynoApiProvider,
  	public toastCtrl: ToastController) {

    let date        = moment();
  	//var date = new Date();
  	//date.setHours(2, 0, 0, 0);

  	this.expenseItem = {
  		Artikelnummer: 'S100100',
  		Datum: date.format('YYYY-MM-DD'),
  		Einzelpreis: 0,
  		Netto: 0,
  		Menge: 1,
  		SteuerCode: '0'
  	};

  	this.calc();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpenseItemCreatePage');
  }

  calc(){
  	console.log(this.expenseItem.Artikelnummer)
  	console.log(this.expenseItem)
  	switch (this.expenseItem.Artikelnummer) {
  		case "S100100":
        this.expenseItem.Bezeichnung = 'Mittagessen';
        this.expenseItem.Einzelpreis = 25;
        break;
      case "S100107":
        this.expenseItem.Bezeichnung = 'Abendessen';
        this.expenseItem.Einzelpreis = 35;
        break;
  		case "S100101":
  			this.expenseItem.Bezeichnung = 'Arbeitsweg in KM';
  			this.expenseItem.Einzelpreis = 0.7;
  			break;
  		case "S100102":
  			this.expenseItem.Bezeichnung = 'Pauschalspesen';
  			this.expenseItem.Einzelpreis = 400;
  			break;
  		case "S100103":
  			this.expenseItem.Bezeichnung = 'Büromaterial';
  			//this.expenseItem.Preis = 0;
  			break;
  		case "S100104":
  			this.expenseItem.Bezeichnung = 'Diverses';
  			//this.expenseItem.Preis = 0;
  			break;
  		case "S100105":
  			this.expenseItem.Bezeichnung = 'BYD Pauschale';
  			this.expenseItem.Einzelpreis = 200;
  			break;
  		case "S100106":
  			this.expenseItem.Bezeichnung = 'Arbeitsweg mit ÖV';
  			//this.expenseItem.Preis = 0;
  			break;
  		default:
  			// code...
  			break;
  	}

  	this.expenseItem.Netto = this.expenseItem.Einzelpreis * this.expenseItem.Menge; 

  	switch (this.expenseItem.SteuerCode) {
  		case "0":
  			this.expenseItem.Steuerprozent = 0;
  			//this.expenseItem.SteuerCode = '0';
  			//this.expenseItem.Menge = '2';

  			break;
  		case "1":
  			this.expenseItem.Steuerprozent = 7.7;
  			break;
  		case "2":
        this.expenseItem.Steuerprozent = 2.5;
        break;
      case "3":
        this.expenseItem.Steuerprozent = 3.7;
        break;
  		
  		default:
  			// code...
  			break;
  	}


  }
  createExpenseItem(){
  	this.rhynoApi.createExpenseItem(this.expenseItem).subscribe(data => {
  		console.log(data)
  		var respData = JSON.parse(data['_body']);
       if (respData['success']){
          this.presentToast('Spesenbeleg gespeichert');
          this.navCtrl.pop();

      }else{
        this.presentToast(respData['message']);
      }

  		
  	});
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/expense-item-create/expense-item-create.ts